import type { LanguageTexts } from './types';

// Draft texts — to be reviewed by a data-protection lawyer before commercial use (see docs/HANDOFF.md).
export const sl: LanguageTexts = {
  consentTitle: 'Piškotki na tej strani',
  consentDescription:
    'Uporabljamo nujne piškotke, brez katerih stran ne deluje. Z vašo privolitvijo bi uporabili tudi piškotke za {purposes}, vključno s piškotki tretjih ponudnikov. Izbiro lahko kadar koli spremenite ali prekličete z gumbom v spodnjem kotu strani.',
  consentDescriptionNecessaryOnly:
    'Uporabljamo samo nujne piškotke, brez katerih stran ne deluje. Zanje privolitev ni potrebna.',
  controllerLine: 'Upravljavec: {controller}.',
  acceptAll: 'Sprejmi vse',
  rejectAll: 'Zavrni vse',
  preferences: 'Nastavitve',
  save: 'Shrani izbiro',
  close: 'Zapri',
  serviceCounter: 'storitev|storitve',
  preferencesTitle: 'Nastavitve piškotkov',
  introTitle: 'Kako uporabljamo piškotke',
  introDescription:
    'Piškotki so majhne datoteke, ki jih stran shrani v vaš brskalnik. Spodaj izberete, katere dovolite. Nujni piškotki so vedno vklopljeni.',
  necessaryTitle: 'Nujni piškotki',
  necessaryDescription:
    'Potrebni so za delovanje in varnost strani ter za shranjevanje vaše izbire o piškotkih. Zanje privolitev ni potrebna.',
  categories: {
    functional: {
      title: 'Funkcionalni piškotki',
      description: 'Omogočajo dodatne funkcije, na primer vgrajene zemljevide in zapomnjene nastavitve.',
      purpose: 'dodatne funkcije',
    },
    analytics: {
      title: 'Analitični piškotki',
      description:
        'Pomagajo nam razumeti, kako obiskovalci uporabljajo stran (na primer, katere strani so najbolj obiskane), da jo lahko izboljšamo.',
      purpose: 'merjenje obiska',
    },
    marketing: {
      title: 'Oglaševalski piškotki',
      description:
        'Uporabljajo jih oglaševalski partnerji in ponudniki vgrajenih vsebin (na primer videov), da prikažejo ustreznejše oglase in merijo njihovo uspešnost. Lahko spremljajo vaše obiske tudi na drugih straneh.',
      purpose: 'oglaševanje',
    },
  },
  moreTitle: 'Več informacij',
  moreDescription: 'Več o piškotkih in vaših pravicah preberite v {policyLink}.',
  policyLinkText: 'politiki piškotkov',
  policyTitle: 'Politika piškotkov',
  and: 'in',
  poweredBy: 'Omogoča',
  revisitLabel: 'Nastavitve piškotkov',
  iframeNotice: 'Za prikaz te vsebine je potrebna privolitev za kategorijo »{category}«.',
  iframeButton: 'Dovoli in prikaži',
  tableName: 'Piškotek',
  tableProvider: 'Ponudnik',
  tablePurpose: 'Namen',
  tableDuration: 'Trajanje',
  session: 'Seja',
  consentCookiePurpose: 'Shrani vašo izbiro o piškotkih.',
  otherCookiesTitle: 'Drugi piškotki',
  otherCookiesNote: 'Piškotki te strani, ki jih Kockica ne prepozna. Za podrobnosti se obrnite na upravljavca.',
  noCookies: 'Na tej strani nismo zaznali piškotkov, ki bi potrebovali privolitev.',
};
